import { SessionNoteFooterLeftToolbar } from './session-note-footer/session-note-footer-left-toolbar';
import { SessionNoteFooterRightToolbar } from './session-note-footer/session-note-footer-right-toolbar';

interface Props {
    isNoteSaving: boolean;
}

export function SessionNoteFooter({ isNoteSaving }: Props) {
    return (
        <div className="absolute bottom-0 right-0 left-0 z-10 pointer-events-none">
            <div className="bg-card border-t border-muted px-6 py-3 pointer-events-auto">
                <div className="flex items-center justify-between">
                    <SessionNoteFooterLeftToolbar />
                    <SessionNoteFooterRightToolbar isNoteSaving={isNoteSaving} />
                </div>
            </div>
        </div>
    );
}
